<div class="web-card-v-1">
  <div class="web-card-v-1__inner">
    <div class="web-card-v-1__inner-image">
      <fr8bot-ui-icon [name]="icon()" [size]="50" />
    </div>

    <div class="web-card-v-1__inner-text">
      <h3 class="web-card-v-1__inner-text-title">
        {{ title() }}
      </h3>

      <div class="web-card-v-1__inner-text-description">
        {{ description() }}
      </div>
    </div>
  </div>
</div>
